/*
 * @Author: Lingxuyue chenxu@libawall.cn
 * @Date: 2023-09-19 17:48:29
 * @LastEditors: cyx
 * @LastEditTime: 2024-04-29 17:32:07
 * @FilePath: \yda-qywx-h5\src\utils\attachment.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 刘志坤
// 企业微信、钉钉  JSAPI鉴权

import { getAuthorization } from '@/api/login/login.js'
import { environmentJudge, APP } from './utils'
import { Device } from '@hybird/device'
import { useDeviceStore } from '@/store/home'

// 企业微信api鉴权
export const getAuthorizations = async () => {
  console.log('我是企业微信的开始是否进来了11')
  const res = await getAuthorization({
    url: window.location.href,
    sysCode: 1
    // isApply: 0,
  })
  console.log('res', res)
  wx.config({
    beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: res.data.appId, // 必填，企业微信的corpID
    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
    jsApiList: [
      'previewFile',
      'chooseImage',
      'getLocalImgData',
      'setKeepScreenOn',
      'agentConfig',
      'checkJsApi',
      'scanQRCode',
      'shareWechatMessage',
      'shareAppMessage'
    ] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
  })
  console.log('config结束')

  wx.ready(async function () {
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    console.log('ready')

    // wx.checkJsApi({
    //   jsApiList: ['agentConfig', 'setKeepScreenOn'], // 需要检测的JS接口列表
    //   success: function (res) {
    //     console.log(res, '我看啊看你是绝代风华精神的粉红色')
    //     // 以键值对的形式返回，可用的api值true，不可用为false
    //     // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
    //   },
    // })

    // const result = await getAuthorization({
    //   url: window.location.href,
    //   sysCode: 1,
    //   isApply: 1,
    // })

    // wx.agentConfig({
    //   corpid: result.data.appId, // 必填，企业微信的corpid，必须与当前登录的企业一致
    //   agentid: result.data.agentid, // 必填，企业微信的应用id
    //   timestamp: result.data.timestamp, // 必填，生成签名的时间戳
    //   nonceStr: result.data.nonceStr, // 必填，生成签名的随机串
    //   signature: result.data.signature, // 必填，签名，见附录1
    //   jsApiList: ['setKeepScreenOn'], //必填
    //   success: function (res) {
    //     console.log(res, '成功回调')
    //     wx.invoke(
    //       'setKeepScreenOn',
    //       {
    //         keepScreenOn: true,
    //       },
    //       function (res) {
    //         console.log('常亮回调', res)
    //       }
    //     )
    //   },
    //   fail: function (res) {
    //     console.log(res, '我注入应用身份失败了')
    //     if (res.errMsg.indexOf('function not exist') > -1) {
    //       alert('版本过低请升级')
    //     }
    //   },
    // })
    // wx.onHistoryBack(async function () {
    //   const deviceStore = useDeviceStore()

    //   var deviceProtocol = Device.getByNumber(
    //     deviceStore.connectDeviceNumber
    //   )?.deviceProtocol

    //   await deviceProtocol?.disconnect()
    //   return true
    // })
  })
}

// 钉钉api鉴权
export const dingtalkAuthentication = async () => {
  console.log('我进来了1111')
  const res = await getAuthorization({
    url: window.location.href,
    sysCode: 2
  })
  console.log('res', res)
  const corpId = localStorage.getItem('corpId')
  console.log('corpId', corpId)

  dd.config({
    debug: false,
    agentId: res.data.appId, // 必填，微应用ID
    corpId: corpId, //必填，企业ID
    timeStamp: res.data.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.data.nonceStr, // 必填，自定义固定字符串。
    signature: res.data.signature, // 必填，签名
    type: 0, //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
    jsApiList: [
      'biz.util.openLocalFile',
      'biz.util.downloadFile',
      'biz.util.uploadImageFromCamera',
      // 'biz.util.scan',
      'biz.util.setScreenKeepOn',
      'biz.util.uploadAttachmentToDingTalk',
    ] // 必填，需要使用的jsapi列表，注意：不要带dd。
  })
  console.log(dd, 'wowowowowowowowowwowo')
  // dd.biz.util.setScreenKeepOn({
  if (dd.biz.util.setScreenBrightnessAndKeepOn) {
    dd.biz.util.setScreenBrightnessAndKeepOn({
      brightness: 0.5,
      isKeep: true,
      onSuccess: function () {
        console.log('设置屏幕常亮0.5成功了')
      },
      onFail: function (error) {
        console.log(error, '设置屏幕常亮失败了')
      }
    })
  }

  dd.error(function (err) {
    alert('钉钉鉴权失败: ' + JSON.stringify(err))
  }) //该方法必须带上，用来捕获鉴权出现的异常信息，否则不方便排查出现的问题
}

export const setScreenBrightnessAndKeepOn = async () => {
  if (environmentJudge() == APP) return
  if (!dd.biz.util.setScreenBrightnessAndKeepOn) return
  dd.biz.util.setScreenBrightnessAndKeepOn({
    brightness: 0.5,
    isKeep: true,
    onSuccess: function () {
      console.log('设置屏幕常亮0.5成功了')
    },
    onFail: function (error) {
      console.log(error, '设置屏幕常亮失败了')
    }
  })
}

//飞书鉴权
export const feishuAuthorizations = async () => {
  const res = await getAuthorization({
    url: window.location.href,
    sysCode: 5
    // isApply: 0,
  })
  window.h5sdk.config({
    appId: res.data.appId,
    timestamp: +res.data.timestamp,
    nonceStr: res.data.nonceStr,
    signature: res.data.signature,
    jsApiList: [
      'biz.util.scanCode',
      'biz.util.openDocument',
      'biz.util.downloadFile',
      'biz.util.getSetting',
      'biz.util.getUserInfo'
    ],
    //成功回调
    onSuccess: (res) => {
      console.log(`config success: ${JSON.stringify(res)}`)
    },
    //失败回调
    onFail: (err) => {
      console.log(`config failed: ${JSON.stringify(err)}`)
    }
  })
}
